import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatementDetail } from '@/features/accounting-reconciliation/statement-detail'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one bank statement's reconciliation workspace.
 *
 * The grant guard is `accounting_reconciliation.view`, the same key as the
 * list. Whether the caller may see THIS statement is the API's answer, not
 * the browser's: tenancy scoping makes another company's statement a 404.
 */
export const Route = createFileRoute('/_authenticated/accounting/reconciliation/$statementId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_reconciliation.view')) {
      throw redirect({ to: '/accounting/reconciliation' })
    }
  },
  component: AccountingReconciliationDetailRoute,
})

function AccountingReconciliationDetailRoute() {
  const { statementId } = Route.useParams()

  return <StatementDetail statementId={statementId} />
}
